import { isAxiosError } from "axios"
import {
  BATTLE_DENIAL_REASON,
  IBattleDenialBody
} from "@/store/apis/battleAPI/battle.types"

export type IBattleFailure = "REREAD" | "REJECTED" | "FAILED"

const REREAD_REASONS: readonly BATTLE_DENIAL_REASON[] = [
  BATTLE_DENIAL_REASON.ROUND_RESOLVED,
  BATTLE_DENIAL_REASON.AUTO_BATTLE_ON,
  BATTLE_DENIAL_REASON.BATTLE_CLOSED
]

export const battleFailureOf = (error: unknown): IBattleFailure => {
  if (!isAxiosError<Partial<IBattleDenialBody>>(error)) {
    return "FAILED"
  }
  const status = error.response?.status
  if (status === 400) {
    return "REJECTED"
  }
  const reason = error.response?.data?.reason
  if (status === 409 && REREAD_REASONS.some((known) => known === reason)) {
    return "REREAD"
  }
  return "FAILED"
}
